<template>
	<div class="btn-group" role="group" aria-label="...">
		<router-link
			class="btn btn-default"
			:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/tasks'"
			title="Todas">
			Todas
		</router-link>

		<router-link
			v-for="status in statuses"
			:key="status.id"
			:class="'ladda-button btn btn-'+status.class "
			:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/tasks/status/'+status.slug"
			:title="status.lang.name"
			v-html="status.icon">
		</router-link>

		<router-link
			class="btn btn-default"
			:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/tasks/status/completed'"
			title="Completadas">
			<i class="fa fa-check-square-o" aria-hidden="true"></i>
		</router-link>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		components: {

		},
		data () {
			return {
				statuses: null,
			}
		},
		created () {
			this.init()
		},
		watch: {
			'$i18n.locale'() {
				this.reload();
			}
		},
		methods: {
			init() {
				this.getStatuses()
			},
			reload() {
				this.getStatuses()
			},
			getStatuses() {
				this.$http.get('admin/projects/tasks/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/ToolbarStatuses.vue